import { SearchInputEventDetails } from "@/types/types";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("basic-search-input")
class BasicSearchInput extends LitElement {
	static readonly styles = css`
		.default-search {
			display: flex;
			align-items: center;
			background: white;
			border: var(--border-default);
			padding: 10px 15px;
			border-radius: var(--border-radius);
			max-width: 400px;
		}

		.search-icon {
			font-size: 1.2rem;
			color: var(--color-sand);
		}

		.search-input {
			flex: 1;
			border: none;
			outline: none;
			font-family: var(--font-text);
			font-size: 1rem;
			color: black;
			padding-left: 10px;
		}
	`;

	@property({ type: String }) placeholder = "Search...";
	@property({ type: String }) value = "";

	private handleInput(event: Event) {
		const target = event.target as HTMLInputElement;
		this.value = target.value;
		this.dispatchEvent(new CustomEvent<SearchInputEventDetails>(CustomEventType.SEARCH_CHANGE, {
			detail: { value: this.value },
			bubbles: true,
			composed: true
		}));
	}

	render() {
		return html`
			<div class="default-search">
				<span class="search-icon">🔍</span>
				<input 
					type="text" 
					class="search-input"
					.placeholder="${this.placeholder}"
					.value="${this.value}"
					@input="${this.handleInput}"
				>
			</div>
		`;
	}
}

export default BasicSearchInput;